<template>
  <!-- 支付方式图标区域 -->
  <section class="payment-icons-section d-flex align-items-center">
    <div class="container-fluid payment-icons-container">
      <div class="row justify-content-center m-5 title">
        一鍵對接 週期自選 / UUPAY 金流數據皆瞬現
      </div>
      <!-- <div class="row justify-content-around m-5 pb-1">
        <div class="col-auto">
          <img src="@/assets/uupay/images/alipay.png" alt="Alipay" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/applePay.png" alt="ApplePay" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/gpay.png" alt="GPay" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/circlePay.png" alt="VISA" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/visaPay.png" alt="JPay" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/yandexPay.png" alt="DISCOVER" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/jcbPay.png" alt="DISCOVER" class="payment-icon">
        </div>
        <div class="col-auto">
          <img src="@/assets/uupay/images/discoverPay.png" alt="DISCOVER" class="payment-icon">
        </div>
      </div> -->
      <div class="row m-5 pb-1">
        <div class="horizontal-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in items" :key="index">
              <div class="slide-content">
                <img :src="item.imgSrc" class="payment-icon">
              </div>
            </div>
          </div>
          <!-- 分页器 -->
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper, { Navigation, Pagination } from 'swiper'

export default {
  name: 'UUPayMethod',
  data() {
    return {
      items: [
        { imgSrc: require('@/assets/uupay/images/alipay.png') },
        { imgSrc: require('@/assets/uupay/images/applePay.png') },
        { imgSrc: require('@/assets/uupay/images/gpay.png') },
        { imgSrc: require('@/assets/uupay/images/circlePay.png') },
        { imgSrc: require('@/assets/uupay/images/visaPay.png') },
        { imgSrc: require('@/assets/uupay/images/yandexPay.png') },
        { imgSrc: require('@/assets/uupay/images/jcbPay.png') },
        { imgSrc: require('@/assets/uupay/images/discoverPay.png') },
      ]
    }
  },
  methods: {
    initSwiper() {
      this.swiperInstance = new Swiper('.horizontal-swiper-container', {
        direction: 'horizontal', // 水平方向(默认值，可省略)
        slidesPerView: 6,       // 同时显示的幻灯片数量
        spaceBetween: 30,       // 幻灯片间距
        loop: false,             // 循环模式
        centeredSlides: false,   // 活动幻灯片居中
        autoplay: {             // 自动播放
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {           // 分页器
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {         // 响应式断点
          640: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
          1440: {
            slidesPerView: 6
          }
        }
      })
    }
  },
  beforeDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true)
    }
  },
  mounted() {
    this.initSwiper()
  }
}
</script>
<style scoped>
.payment-icons-section {
  background-color: #f8f8f8;
  position: relative;
  z-index: 1;
}

.payment-icons-container {
}
.payment-icons-container .title {
  font-size: 20px;
  line-height: 30px;
  color: #21042e;
}

.payment-icons-container .payment-icon {
  width: auto;
  height: 40px;
  margin: 0 10px;
}

.horizontal-swiper-container {
  width: 100%;
  margin: 20px auto;
}

.swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>


// WEBPACK FOOTER //
// src/components/uupayMethod.vue